import { TableCell, TableRow } from '@/components/ui/Table';

export const StatusRow = ({
  message,
  columnCount,
}: {
  message: string;
  columnCount: number;
}) => (
  <TableRow className="border-none">
    <TableCell colSpan={columnCount} className="py-16 text-center">
      <span className="text-sm text-foreground-muted">{message}</span>
    </TableCell>
  </TableRow>
);
